/**
 * Android (and iOS) only route a browser's audio to the CALL channel — the one
 * the volume rocker controls during a phone call, and the one that can use the
 * earpiece — while the microphone is actually being captured. A student who
 * never unmutes therefore hears the class on the MEDIA channel, which is why
 * the volume buttons felt wrong and it never behaved like a call.
 *
 * So on mobile we hold a silent capture open for the whole class. It is never
 * published, never recorded, never sent anywhere — it exists purely to keep the
 * browser in "call" mode. It is released the moment the student's own mic goes
 * live (LiveKit then owns the capture) and re-taken when they mute again.
 */
let holder = null;
let pending = null;

export const isMobileDevice = () =>
  /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent || "");

export async function holdCallAudio() {
  if (!isMobileDevice()) return false;
  if (holder) return true;
  if (pending) return pending;
  pending = (async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true },
      });
      holder = stream;
      console.info("[call-audio] holding silent capture — volume keys now control call audio");
      return true;
    } catch (e) {
      console.info("[call-audio] not available:", e?.name || e);
      return false;
    } finally {
      pending = null;
    }
  })();
  return pending;
}

export function releaseCallAudio() {
  if (!holder) return;
  holder.getTracks().forEach((t) => {
    try {
      t.stop();
    } catch (_) {}
  });
  holder = null;
}

export const isHoldingCallAudio = () => !!holder;
